import { createContext } from "react";
import { ApiResult } from "@/shared/utils";
import type { Login, UserInfo, UserOrganization } from "../types";

export type SessionContextType = {
    status: 'loading' | 'ready';
    user: UserInfo | null;
    isAuthenticated: boolean;
    login: (payload: Login) => Promise<ApiResult<void>>;
    logout: () => Promise<void>;
    userOrganizations: UserOrganization[];
    currentOrganization: UserOrganization;
    switchOrganization: (organizationId: string) => void;
}

export const SessionContext = createContext<SessionContextType | undefined>(undefined);
